module.exports = __webpack_public_path__ + "media/card_animation.f32b1fa7.webm";